import { createRouter, createWebHistory } from 'vue-router'

export const INITIAL_ROUTE_PATH = '/single-view/carrier_find/carrier_find_all'
export const INITIAL_ROUTE_NAME = 'single-view'

const router = createRouter({
  history: createWebHistory(),
  routes: [],
})

export default router
